// extracted by mini-css-extract-plugin
module.exports = {"list":"CheckboxMultiSelectList_list__3hYRU"};